import { render, staticRenderFns } from "./Permit.vue?vue&type=template&id=2623d0ce&scoped=true&"
import script from "./Permit.vue?vue&type=script&lang=js&"
export * from "./Permit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2623d0ce",
  null
  
)

export default component.exports